import React from 'react'
import { Navigate } from 'react-router'
import { AppRoutes } from '@core/AppRoutes'
import { useNewSportsOfferingFeature } from './hooks/useNewSportsOfferingFeature'

const SportsOfferingLazyRoute = React.lazy(() => import('./Components/MainSportsOffering'))

export const SportOfferingRoot: React.FC = () => {
  const isKambiSportsOfferingEnabled = useNewSportsOfferingFeature()

  if (!isKambiSportsOfferingEnabled) {
    return <Navigate to={AppRoutes.SportsRoot + '/home'} replace />
  }
  return (
    <React.Suspense fallback={null}>
      <SportsOfferingLazyRoute />
    </React.Suspense>
  )
}
